<template>
  <v-row class="mb-2">
    <v-col cols="8" class="mx-n4 mt-1">
      <v-card-title>Changer le critère de tri</v-card-title>
    </v-col>
    <v-col cols="10" class="mt-n7">
      <v-autocomplete
        v-model="actionValue.sortCriterion"
        item-text="label"
        item-value="value"
        item-color="info"
        menu-props="light"
        label="Sélectionner un item"
        :items="sortOptions"
        color="blue"
        clearable
        :rules="[validateRequired]"
      />
    </v-col>
  </v-row>
</template>

<script setup>
import { ref, reactive } from 'vue';

const props = defineProps({ action: { type: Object, required: true } });

const actionValue = ref(props.action);

const sortOptions = ref([
  { label: 'Du - cher au + cher', value: 'prix_sort_asc' },
  { label: 'Du + cher au - cher', value: 'prix_sort_desc' },
  { label: 'Du + court au + long', value: 'duration_sort_asc' },
  { label: 'Du + long au + court', value: 'duration_sort_desc' }
]);

const validateRequired = v => !!v || 'Required';
</script>

<style>
</style>
